import React from 'react'

import { Navbar, Footer, Newsbar } from '../../components';
import { ContactUs } from "./"

export default function Contact() {
  return (
    <div className='emas__contact'>
      <Navbar />
      <ContactUs />
      <Newsbar />
      <Footer />
    </div>
  )
}
